import Vuex from 'vuex';
import auth from './modules/auth';

import discussion from './modules/discussion';
import general from './modules/general';
import story from './modules/story';
import news from './modules/news';
import game from './modules/game';
import gameActivity from './modules/gameActivity';
import trailer from './modules/trailer';
import giveaways from './modules/giveaways';
import interaction from './modules/interaction';
import matchStore from './modules/matchStore';
const store = new Vuex.Store({
    modules: {
        admin: {
            namespaced: true,
            modules: {
                auth: auth,
                discussion: discussion,
                general: general,
                story: story,
                news: news,
                game: game,
                gameActivity: gameActivity,
                trailer: trailer,
                giveaways: giveaways,
                interaction: interaction,
                matchStore: matchStore
            },
        }
    }
})

export default store;